// extracted by mini-css-extract-plugin
module.exports = {"CrumbsWrap":"Crumbs_CrumbsWrap__2AjWM","Crumbs":"Crumbs_Crumbs__17af-"};